import { MutationTree } from 'vuex';
import * as types from '@webparts/store/types'
import {
  CalendarEventResponseData,
  EwsCalendarFolder,
  CalendarFolderInfo,
} from '@webparts/components/webparts/YASKAWA/Calendar/types';

export default <MutationTree<webpartv3.state.WebpartsState>>{
    [types.WEBPART_COMMONDATA_MOUNTED](state, payload: boolean) {
        state.infoMounted = payload;
    },

    [types.WEBPART_UNREADMAIL_DATA](state, payload: ewsResponse.ewsMail[]) {
        state.unreadMails = payload;
    },

    [types.WEBPART_CALENDARFOLDER_DATA](state, payload: EwsCalendarFolder[]) {
        state.calendarFolders = payload.map(f => <CalendarFolderInfo>{
            id: f.id,
            color: {
                category: '',
                hasColor: f.colorCode != null,
                code: f.colorCode
            }
        });
    },

    [types.WEBPART_CALENDARTODAYEVENT_DATA](state, payload: CalendarEventResponseData[]) {
        state.todayEvents = payload;
    },

    [types.WEBPART_CALENDARDAILYEVENT_DATA](state, payload: CalendarEventResponseData[]) {
        state.dailyEvents = payload;
    },

    [types.WEBPART_CALENDARMONTHLYEVENT_DATA](state, payload: CalendarEventResponseData[]) {
        state.monthlyEvents = payload;
    },
};
